module.exports = __webpack_public_path__ + "static/media/project-thumbnail01.4a00f4a3.jpg";